import React from 'react';
import classnames from 'classnames';
import ListRenderGuide from '@gp/components/ListRenderGuide';
import ReportWallpaper from '../../../components/ReportWallpaper';
import Comment, { ICommentValue } from '../Comment';
import UpdatesOfWeek from '../UpdatesOfWeek/ReviewUpdatesOfWeek';
import MemoPendingApproval from '../MemoPendingApproval/ReviewMemoPendingApproval';
import Calendar from '../Calendar/ReviewCalendar';
import useAutoScroll from '../../_hooks/useAutoScroll';
import { getIsShowGRDate } from '../../utils';

import type { IBaseProps } from '@home/types/common';
import type {
  IDPSReportMemoPendingApprovalVO,
  IDPSReportUpdatesOfTheWeekVO,
  IDPSReportVOV3,
  IDPSReportCalendarValue,
  IDPSReportModuleTitles,
} from '@gp/types/dpsReport/v3';

import '../../../v2/components/ReviewReport/index.scss';

interface IReviewEditableReportProps extends IBaseProps {
  reportScrollableNode?: React.RefObject<HTMLDivElement>;
  node?: React.RefObject<HTMLDivElement>;
  dateTitle?: string;
  report?: (IDPSReportVOV3 & IDPSReportModuleTitles) | null;
}

const ReviewEditableReport: React.FC<IReviewEditableReportProps> = (props) => {
  const { style, className, reportScrollableNode, node, dateTitle, report } = props;

  const {
    report_id: reportId,
    comment_title: commentTitle,
    comment,
    project_comment: projectComment,
    changes_title: changesTitle,
    changes,
    memo_title: memoTitle,
    memo,
    calendar_title: calendarTitle,
    calendar,
    start_date_dps_report_week: startDate,
    end_date_dps_report_week: endDate,
  } = report || {};
  const commentValue: ICommentValue = {
    comment: comment || '',
    commentsUpdates: projectComment || [],
  };

  const showGRDate = getIsShowGRDate(startDate);

  useAutoScroll({ reportScrollableNode });

  return (
    <ReportWallpaper
      ref={node}
      style={style}
      className={classnames('dbg-dps-report__review-editable-report', className)}
      dateTitle={dateTitle}
    >
      {(!!comment?.trim() || (Array.isArray(projectComment) && projectComment.length > 0)) && (
        <Comment readonly title={commentTitle} value={commentValue} />
      )}
      <ListRenderGuide list={changes}>
        <UpdatesOfWeek title={changesTitle} value={changes as IDPSReportUpdatesOfTheWeekVO[]} />
      </ListRenderGuide>
      <ListRenderGuide list={memo}>
        <MemoPendingApproval
          showGRDate={showGRDate}
          reportId={reportId}
          title={memoTitle}
          value={memo as IDPSReportMemoPendingApprovalVO[]}
        />
      </ListRenderGuide>
      <ListRenderGuide list={calendar?.list}>
        <Calendar
          title={calendarTitle}
          date={endDate}
          value={calendar as IDPSReportCalendarValue}
        />
      </ListRenderGuide>
    </ReportWallpaper>
  );
};

export default ReviewEditableReport;
